<template>
    <!-- 消息通知详情 -->
    <div  class="Booking">
    <TopNavigation  class="topNavigation"></TopNavigation>
    <div class="typeArea">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/Message' }">消息通知</el-breadcrumb-item>
            <el-breadcrumb-item class="bread">通知详情</el-breadcrumb-item>
        </el-breadcrumb>

        <div class="content">
            <div class="tit">
                <div v-html="detailTitle"></div>
            </div>
            <div class="time">
                <div v-html="detailDate"></div>
            </div>
            <div class="detail">
                <div v-html="detailContent"></div>
                <div class="boxDetail" v-show="form.send_type==6">
                    <div class="boxtitle">箱型详情</div>
                    <el-table
                        :data="boxtype"
                        border
                        :header-cell-style="{ background: '#f9f9f9' }"
                        style="width: 360px">
                        <el-table-column
                            prop="box_type"
                            label="箱型">
                        </el-table-column>
                        <el-table-column
                            prop="number"
                            label="数量">
                        </el-table-column>
                    </el-table>
                </div>
                <el-button v-show="form.send_type==2 && form.notice_type==1  && form.order_info != undefined" type="text" @click="chakan">去查看</el-button>
                <el-button v-show="form.send_type==6" type="text" @click="chakan" class="qudingcang">
                   <div class="qdc">
                    <span>去订舱</span>
                    <img src="@/assets/images/Arrow.png" alt="">
                   </div>
                </el-button>
            </div>
        </div>
    </div>
    <Bottom />
    </div>
</template>
    
<script>
import { userNoticeDetail,unReadNum } from "@/api/api";
import Bottom from '../HP/BottomPage.vue';
import TopNavigation from "../HP/TopNavigationB.vue";
export default {
    components:{
        Bottom,
        TopNavigation,
    },
    data() {
        return {
            headers: {
                token: localStorage.getItem("token"),
            },
            detailTitle:'',
            detailContent:'',
            detailDate:'',
            form:'',
            boxtype:[],
        }
    },
    methods: {
        async getDetail(){
            try {
                const res = await userNoticeDetail(this.$route.query,this.headers)
                if(res.code==1){
                    this.detailDate=this.showHtml(res.data.create_time);
                    this.detailTitle=this.showHtml(res.data.title);
                    this.detailContent=this.showHtml(res.data.content);

                    this.detailContent += res.data.send_type==6?'？':''
                    
                    this.form = res.data
                    this.boxtype = res.data.boxtype
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
        // 富文本处理
        showHtml(str) {
            return str
                .replace(str ? /&(?!#?\w+;)/g : /&/g, "&amp;")
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .replace(/&quot;/g, '"')
                .replace(/&#39;/g, "'")
                .replace(/&amp;nbsp;/g, "\u3000");
        },
        // 调用接口  获取未读数量
        async getUnReadNum(){
            try {
                const res = await unReadNum({token:localStorage.getItem('token')})
                let storedObject = localStorage.getItem('userInfo');
                if (storedObject) { 
                    let obj = JSON.parse(storedObject);
                    obj.unread_num = res.data.unread_num;
                    localStorage.setItem('userInfo', JSON.stringify(obj)); // 重新存储对象
                    // location.reload()  // 修改本地存储  刷新页面
                }      
            } catch (error) {
                console.log(error,'失败');
            }
        },
        chakan(){   
            if(this.form.send_type==6 || this.form.send_type==7){ // 6去订舱  舱位确认  精选运价  // 7 盯舱宝
                // send_type==6：boxtype 有值，舱位确认，shipping_space_id 舱位id
                let pathName = this.form.shipping_space_info.type == 1 ? 'BookingSpace':'MarketBookingSpace'
                this.$router.push({
                    name:pathName,
                    params:{
                        shipping_space:true,
                        shipping_space_id:this.form.shipping_space_info.shipping_space_id
                    } // shipping_space_id 携带舱位id 获取舱位详情
                })
                // 跳转到订舱页  判断使用存在shipping_space_id  存在调用舱位详情接口
                // 舱位详情：/api/SeaFclFreight/shippingSpaceDetail?shipping_space_id=16
            }else if(this.form.send_type==2 && this.form.notice_type==1){ // 查看订单详情
                // send_type==2 && notice_type==1 订舱订单，order_id，订单id
                let pathName = this.form.order_info.type == 1 ? 'OrderDetails':'MarketOrderDetails'
                if(this.form.order_info.order_id!=undefined){
                    this.$router.push({
                        name:pathName,
                        query:{
                            id:this.form.order_info.order_id
                        },
                        params:{
                            id:this.form.order_info.order_id
                        }
                    })
                }
            }
        }
    },
    mounted(){
        this.getDetail()
        this.getUnReadNum()
    }
}
</script>
    
<style style lang="scss" scoped>
.topNavigation{
    height: 100PX;
    display: flex;
    justify-content: space-between;
    padding: 0 80px;
    background: #fff;
}

.Booking{
    background: #F9F9F9;
}
.typeArea{
    width: 1200px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
}


.el-breadcrumb{
    margin: 20px 0;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    .el-breadcrumb__inner is-link{
        color: pink;
    }
}

:deep(.el-breadcrumb){
    .el-breadcrumb__inner{
        color: #999999 !important;
    }
    .bread{
        span{
            color: #0073F5 !important;
        }
    }
}

.content{
    height: 637px;
    background: #FFFFFF;
    border-radius: 12px 12px 12px 12px;
    padding: 32px;

    box-sizing: border-box;

    margin-bottom: 32px;
    .tit{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        font-style: normal;
        text-transform: none;
    }

    .time{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        font-style: normal;
        text-transform: none;

        margin-top: 12px;
        margin-bottom: 20px;
    }

    .detail{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
        font-style: normal;
        text-transform: none;

        overflow: auto;
    }
}

.boxDetail{
    margin-top: 24px;
    .boxtitle{
        font-weight: 600;
    }
    .el-table{
        margin-top: 12px;
    }
}

.qudingcang{
    width: 211px;
    height: 49px;
    background: #0084F6;
    border-radius: 6px 6px 6px 6px;
    font-size: 18px;
    color: #FFFFFF;
    margin-top: 24px;
    
    .qdc{
        display: flex;
        align-items: center;
        justify-content: center;

        img{
            margin-left: 4px;
        }
    }
}
</style>